<div class="upload-queue-head-root" *transloco="let t">
  <div class="upload-queue-grid">
    <app-label class="header" isBig>
      {{ t(labels.fromDate) }}
    </app-label>

    <app-label class="header" isBig>
      {{ t(labels.toDate) }}
    </app-label>

    <app-label class="header" isBig>
      {{ t(labels.status) }}
    </app-label>

    <app-label class="header" isBig>
      {{ t(labels.pointsMigrated) }}
    </app-label>

    <app-label class="header" isBig>
      {{ t(labels.triggeredAt) }}
    </app-label>

    <app-label class="header" isBig>
      {{ t(labels.report) }}
    </app-label>
  </div>

  <div
    class="execution-list"
    *ngIf="executions.length > 0 && !loading"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pullExecutions()"
  >
    <div class="upload-queue-grid">
      <ng-container *ngFor="let execution of executions">
        <app-label class="file date">
          {{
            execution.fromDate
              ? (execution.fromDate | date:'MM/dd/yyyy hh:mm:ss a' )
              : '-'
          }}
        </app-label>

        <app-label class="file date">
          {{
            execution.toDate
              ? (execution.toDate |  date:'MM/dd/yyyy hh:mm:ss a')
              : '-'
          }}
        </app-label>

        <app-label
          class="file status"
          [ngClass]="executionStatusClass(execution.status)"
        >
          {{ execution.status || '-' }}
        </app-label>

        <app-label class="file">
          {{
            execution.pointsMigrated !== undefined &&
            execution.pointsMigrated !== null
              ? execution.pointsMigrated
              : '-'
          }}
        </app-label>

        <app-label class="file date">
          {{
            execution.triggeredAt
              ? (execution.triggeredAt |  date:'MM/dd/yyyy hh:mm:ss a')
              : '-'
          }}
        </app-label>

        <app-secondary-button
          class="file report"
          [title]="t(labels.download)"
          [disabled]="!canDownloadReport(execution)"
          (clickAction)="emitDownloadReport(execution)"
          auxiliaryBlue
        >
          {{ t(labels.download) }}
        </app-secondary-button>
      </ng-container>
    </div>

    <div class="loading-more-items">
      <mat-spinner diameter="15" *ngIf="pulling"></mat-spinner>
    </div>
  </div>

  <div *ngIf="loading" class="loading">
    <mat-spinner diameter="75"></mat-spinner>
  </div>

  <app-label
    *ngIf="!loading && hasError"
    class="empty-queue"
  >
    {{ t(labels.error) }}
  </app-label>

  <app-label
    *ngIf="!loading && !hasError && executions.length === 0"
    class="empty-queue"
  >
    {{ t(labels.empty) }}
  </app-label>
</div>
